<template>
  <!-- 反馈管理 -->
  <div>
    <div class="clearfix">
      <Form
        @submit.native.prevent
        :model="formData"
        label-position="left"
        class="mytable-titleBox"
      >
        <div class="clearfix">
          <FormItem
            label="反馈人昵称:"
            class="fl mytable-title"
            :label-width="86"
          >
            <Input
              v-model="formData.username"
              placeholder="请输入反馈人昵称"
            ></Input>
          </FormItem>
          <FormItem
            label="反馈人手机号:"
            class="fl mytable-title"
            :label-width="110"
          >
            <Input
              v-model="formData.phone"
              placeholder="请输入反馈人手机号"
            ></Input>
          </FormItem>

          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleQuery">查询</Button>
            <Button class="fl" @click="handleReset">重置</Button>
          </div>
        </div>
        <div class="line"></div>

        <RadioGroup
          v-model.trim="type"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
        >
          <!-- <Radio :label="empty">全部</Radio> -->
          <Radio :label="0">待解决</Radio>
          <Radio :label="1">已解决</Radio>
        </RadioGroup>
        <FormItem
          label="日期范围:"
          class="fl mytable-title ml24 mt24"
          :label-width="72"
        >
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
      </Form>
    </div>

    <Table
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
    <!-- 回复弹窗 -->
    <Modal
      v-model="modalVisibile"
      width="600"
      :mask-closable="false"
      title="回复用户"
      @on-cancel="handleCancel"
    >
      <el-scrollbar ref="chatScroll" key="chat" wrapClass="chatScroll">
        <div class="loading" v-show="showLoading"></div>

        <ul class="chartCont" v-for="(item, index) in rebackList" :key="index">
          <li class="clearfix" v-if="!item.owner">
            <img class="poster mr10 fl" :src="item.poster" alt />
            <div class="fl">
              <p class="timestr-l blueFont">
                {{ item.username }} {{ item.createTimeStr }}
              </p>
              <em
                class="reback-content bgBlue"
                v-html="item.content"
                v-show="item.content"
              ></em>
              <div v-show="item.imgList.length">
                <img
                  class="content-img"
                  :src="v1"
                  alt
                  @click="showImg(v1)"
                  v-for="(v1, i1) in item.imgList"
                  :key="i1"
                />
              </div>
            </div>
          </li>
          <li class="clearfix myReply" v-if="item.owner" :key="index">
            <img
              v-if="item.header"
              class="poster ml10 fr"
              :src="item.header"
              alt
            />
            <img
              v-else
              class="poster ml10 fr"
              src="../../assets/images/pic_admin.jpg"
              alt
            />
            <div class="fr">
              <p class="timestr-r blueFont">{{ item.createTime }} 内部料</p>
              <em
                class="reback-content bgBlue"
                v-html="item.content"
                v-show="item.content"
              ></em>
              <div v-if="item.imgList.length" class="imgR">
                <div v-for="(v1, i1) in item.imgList" :key="i1" class="imgR">
                  <img class="content-img" :src="v1" alt @click="showImg(v1)" />
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div></div>
      </el-scrollbar>
      <div class="myReplyInput">
        <div class="clearfix"></div>
        <p class="lineRe"></p>
        <div
          class="uploadBox"
          style="
            overflow: hidden;
            width: 30px;
            height: 30px;
            border: 1px dashed #d9d9d9;
          "
        >
          <!-- <img v-if="imgSrc" :src="imgSrc" width="88" height="88" class="img-obj" /> -->
          <Upload
            ref="upload"
            :on-success="() => {}"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048"
            :before-upload="beforeImgUpload"
            type="drag"
            action
            style="display: inline-block; width: 88px"
          >
            <div style="width: 30px; height: 30px; line-height: 30px">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
        </div>

        <el-scrollbar key="content" wrapClass="chatRecord">
          <div
            ref="chatbox"
            id="chatInput"
            class="chat-put"
            :contenteditable="imgSrc ? false : true"
          ></div>
        </el-scrollbar>
      </div>

      <div slot="footer">
        <div slot="footer" class="clearfix edit-footer">
          <i style="color:#666;margin-top:-20px;" class="fl">注：最多输入500个字</i>
          <div class="fr" style="height: 34px">
            <Button
              type="primary"
              @click="rebackFeed"
              :loading="rebackLoading"
              :disabled="rebackLoading"
              style="position: relative; right: 18px; bottom: 18px"
              >发送</Button
            >
          </div>
        </div>
        <!-- <Button type="text" @click="handleCancel">取消</Button>
        <Button
          :loading="modalLoading"
          type="primary"
          @click="handleModalSubmit"
          :disabled="isClick"
          >提交</Button
        > -->
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";

export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      type: 0,
      rebackLoading: false,
      imgSrc: "",
      showLoading: true,
      rebackList: [],
      isClick: true,
      //保存是否显示的数组
      isShowArr: [],
      // isShenhe: Number(localStorage.getItem("isShenhe")),
      selectedVal: [],
      empty: "",
      modalLoading: false,
      modalForm: {
        user_id: "",
      },
      modalForm1: {
        user_id: "",
      },
      modalVisibile: false,
      isAdmin: Number(localStorage.getItem("sa")), //1 超级管理员  0作者
      // isAdmin: 0,
      vipData: [],
      date: [],
      formData: {
        complaint_status: "",
      },
      formData1: {
        complaint_status: "",
      },
      tableData: [],
      columns: [
        {
          title: "反馈人昵称",
          align: "center",
          key: "username",
        },
        {
          title: "手机号",
          align: "center",
          key: "phone",
          // render: (h, params) => {
          //   var phone = params.row.complaint_phone
          //     ? params.row.complaint_phone.substr(0, 3) +
          //       "****" +
          //       params.row.complaint_phone.substr(7)
          //     : "无";
          //   return h("span", phone);
          // },
        },
        {
          title: "时间",
          align: "center",
          key: "create_time",
        },
        {
          title: "反馈内容",
          align: "center",
          key: "content",
          tooptip: true,
        },
        {
          title: "未读数",
          key: "unRead",
          align: "center",
          render: (h, params) => {
            return h("span", this.type ? "无" : params.row.unRead);
          },
        },
        {
          title: "操作",
          align: "center",
          key: "age",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true,
                  },
                  on: {
                    click: () => this.handleCheck(params),
                  },
                },
                "回复"
              ),
              this.type == 0 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleSolve(params),
                    },
                  },
                  "解决"
                ),
              this.type == 1 &&
                h(
                  "span",

                  "已解决"
                ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    window.delImg = this.delImg;
    this.handleQuery();
  },
  methods: {
    handleSolve(params) {
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              "解决反馈"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              "确定要解决此反馈吗?"
            ),
          ]);
        },
        onOk: () => {
          this.$api
            .chatSolve({ chat_user_id: params.row.user_id })
            .then((res) => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.getTableData();
              } else {
                this.$Message.error(res.msg);
              }
            });
        },
      });
    },
    /***
     * 回复反馈
     */
    rebackFeed() {
      let content = this.$refs.chatbox.innerText; // 内容

      if (!content && !this.imgSrc) {
        this.$Message.warning("请回复内容!");
        return;
      }

      if (content.length > 500) {
        this.$Message.warning("最多可回复500个字符!");
        return;
      }
      this.rebackLoading = true;
      this.$api
        .chatReply({
          chat_user_id: this.modalForm.chat_user_id,
          content,
          content_img: this.imgSrc,
        })
        .then((res) => {
          this.rebackLoading = false;
          if (res.code == 0) {
            this.$refs.chatbox.innerHTML = "";
            var imgArr = [];
            if (this.imgSrc) {
              imgArr.push(this.imgSrc);
            }
            let chatObj = {
              createTime: "刚刚",
              content,
              owner: 1,
              imgList: imgArr,
            };

            this.rebackList.push(chatObj);
            this.imgSrc = "";
            this.$nextTick((_) => {
              this.toBottom();
            });
          } else {
            this.$Message.warning(res.msg);
          }
        })
        .catch((_) => {
          this.rebackLoading = false;
        });
    },
    beforeImgUpload(file) {
      let that = this;
      // 从后台获取token和key
      this.$api.getQiToken({}).then((res) => {
        if (res.code === 0) {
          let key = res.data.key;
          let token = res.data.QiNiuToken;
          let config = {
            useCdnDomain: true,
            region: null,
          };
          let putExtra = {
            fname: "",
            params: {},
            mimeType: null,
          };
          let observable = qiniu.upload(file, key, token, putExtra, config);
          observable.subscribe({
            error: function (err) {
              this.$Message.success(err);
            },
            complete: function (res) {
              that.modalForm.poster = res.key;
              that.$api.getImgPath({ key: res.key }).then((res) => {
                if (res.code === 0) {
                  that.imgSrc = res.msg;
                  that.$refs.chatbox.innerHTML = `<div class="delImg" onclick="delImg()"><i></i><img id="chatImg" src="${res.msg}" /></div>`;
                }
              });
            },
          });
        } else {
          this.$Message.error(res.msg);
        }
      });
      return false;
    },
    delImg() {
      this.imgSrc = "";
      this.$refs.chatbox.innerHTML = "";
    },
    toBottom() {
      setTimeout(() => {
        let scrollHeight =
          this.$refs["chatScroll"].wrap.firstChild.offsetHeight;
        this.$refs["chatScroll"].wrap.scrollTop = scrollHeight;
      }, 500);
    },

    showImg(poster) {
      this.$pic.init([poster]);
    },
    clickImg(index) {
      this.$pic.init(this.modalForm.complaintImageList, index);
    },
    //回复提交
    handleModalSubmit() {
      if (this.modalForm.id) {
        this.modalLoading = true;
        this.$api
          .complaintReplay({
            reply_content: this.modalForm.reply_content,
            id: this.modalForm.id,
          })
          .then((res) => {
            if (res.code === 0) {
              this.modalVisibile = false;
              this.$Message.success(res.msg);
              this.getTableData();
              this.handleCancel();
            } else {
              this.$Message.error(res.msg);
            }
            this.modalLoading = false;
          });
      }
    },
    //查看
    handleCheck(params) {
      this.modalForm.chat_user_id = params.row.user_id;
      this.$api
        .getChatList({
          ...this.modalForm,
          page_num: 1,
          page_size: 100000,
        })
        .then((res) => {
          if (res.code === 0) {
            this.rebackList = res.data.list;
            this.modalVisibile = true;
            this.$nextTick((_) => {
              this.toBottom();
            });
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    handleCancel() {
      this.modalVisibile = false;
      this.modalForm = Object.assign({}, this.modalForm1);
      this.$refs.chatbox.innerText = "";
      this.imgSrc = "";
      this.getTableData();
    },
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.start_time = val[0] + " 00:00:00";
        this.formData.end_time = val[1] + " 23:59:59";
      } else {
        this.formData.start_time = "";
        this.formData.end_time = "";
      }
      this.handleQuery();
    },
    handleRefundchange() {
      this.handleQuery();
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.date = [];

      this.handleQuery();
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      if (this.type) {
        //已解决
        this.$api
          .feedbackList({
            ...this.formData,
            page_num: this.page_num,
            page_size: this.page_size,
          })
          .then((res) => {
            if (res.code === 0) {
              this.tableData = res.data.list;
              this.total = res.data.total_row;
            } else {
              this.$Message.error(res.msg);
            }
            this.tableLoading = false;
          });
      } else {
        this.$api
          .feedbackUnList({
            ...this.formData,
            page_num: this.page_num,
            page_size: this.page_size,
          })
          .then((res) => {
            if (res.code === 0) {
              this.tableData = res.data.list;
              this.total = res.data.total_row;
            } else {
              this.$Message.error(res.msg);
            }
            this.tableLoading = false;
          });
      }
    },
  },
};
</script>
<style scoped lang="less">
/deep/.delImg {
  position: relative;
  top: 8px;
  width: 120px;
  i {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 16px;
    height: 16px;
    background: #fff url(../../assets/images/delBtn.png) no-repeat;
    -webkit-background-size: 16px 16px;
    background-size: 16px 16px;
    border-radius: 50%;
    cursor: pointer;
  }
}
.lineRe {
  width: 600px;
  height: 1px;
  background: #dce1e6;
  position: relative;
  left: -32px;
  margin-bottom: 14px;
}
.chat-put {
  height: 75px;
  outline: none;
  margin-top: 10px;
  border-bottom: 1px solid #f0f3f5;
  /deep/ img {
    width: 120px;
  }
}
.timestr-r {
  text-align: right;
}
.timestr-l {
  text-align: left;
}
.reback-content {
  max-width: 300px;
  word-break: break-word;
}
/deep/ .chatScroll {
  height: 380px;
}
.content-img {
  max-width: 200px;
  cursor: pointer;
  margin-top: 10px;
}
.imgR {
  text-align: right;
}
.chartCont {
  div {
    max-width: 90%;
  }
  .imgR {
    max-width: 100%;
  }

  li {
    margin-bottom: 20px;

    .poster {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    p {
      color: #8a9299;
      margin-bottom: 10px;
      margin-top: -4px;
    }
    .blueFont {
      color: #1890ff;
    }

    em {
      display: block;
      padding: 6px 10px;
      color: #5c6166;
      font-size: 14px;
      background: rgba(240, 243, 245, 1);
      border-radius: 0px 10px 10px 10px;
      line-height: 22px;
    }
    .bgBlue {
      background: rgba(24, 144, 255, 0.1);
    }
  }

  .myReply {
    em {
      background: #1890ff;
      border-radius: 0;
      border-radius: 10px 0px 10px 10px;
      line-height: 22px;
      color: #fff;
    }
    .grayBg {
      background: #f0f3f5;
      color: #5c6166;
    }
  }
}
.myReplyInput {
  position: relative;
}
.tsImg img {
  width: 150px;
  height: 150px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 12px;
  cursor: pointer;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
/deep/ .btn_true {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/true.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/ .btn_false {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/false.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/.cursor {
  cursor: pointer;
}
/deep/textarea.ivu-input {
  height: 84px;
}
</style>
